export { List as InstanceList } from './List';
export { InstanceDetailsPage } from './Details';
